
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class UpgradeUser extends Vue {
  @Prop() visible!: boolean;

  close() {
    this.$emit("update:visible", false);
  }
}
